"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkOfThePredatorAbilityHandler = exports.MarkOfThePredatorActorAbilityFactory = exports.MarkOfThePredatorAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class MarkOfThePredatorAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MarkOfThePredator;
        this.__typeName = "MarkOfThePredator";
    }
}
exports.MarkOfThePredatorAbilityArgs = MarkOfThePredatorAbilityArgs;
let MarkOfThePredatorActorAbilityFactory = class MarkOfThePredatorActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MarkOfThePredator", "OneEnemies", 3);
    }
};
MarkOfThePredatorActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MarkOfThePredator")
], MarkOfThePredatorActorAbilityFactory);
exports.MarkOfThePredatorActorAbilityFactory = MarkOfThePredatorActorAbilityFactory;
let MarkOfThePredatorAbilityHandler = class MarkOfThePredatorAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "EvilArrow",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 100)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence: sequence.pushSequence("sequential")
                        .push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "EngulfingDarkness")),
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(5),
                    effect: new core_1.VulnerabilityEffectArgs(3),
                });
            },
        });
    }
};
MarkOfThePredatorAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MarkOfThePredator)
], MarkOfThePredatorAbilityHandler);
exports.MarkOfThePredatorAbilityHandler = MarkOfThePredatorAbilityHandler;
